import Controller from './Controller.js';
import FetchExecutor from './services/http/FetchExecutor.js';
import HttpService from './services/http/HttpService.js';
import HttpResponseHandler from './services/http/HttpResponseHandler.js';
import UrlGenerator from './services/UrlGenerator.js';
import RequestBuilder from './services/RequestBuilder.js';
import ValidatorUtils from './validators/ValidatorUtils.js';
import EmailAddressValidator from './validators/EmailAddressValidator.js';
import LoginValidator from './validators/LoginValidator.js';
import LinkAccountValidator from './validators/LinkAccountValidator.js';
import RegisterValidator from './validators/RegisterValidator.js';
import TranslationMapper from './services/TranslationMapper.js';
import TranslationService from './services/TranslationService.js';
import EmailCaptureHandler from './handlers/EmailCaptureHandler.js';
import LoginHandler from './handlers/LoginHandler.js';
import OpenIdLoginHandler from './handlers/OpenIdLoginHandler.js';
import ResetPasswordHandler from './handlers/ResetPasswordHandler.js';
import LinkAccountHandler from './handlers/LinkAccountHandler.js';
import RegisterHandler from './handlers/RegisterHandler.js';
import ViewBuilder from './services/ViewBuilder.js';
import ErrorHandler from './handlers/ErrorHandler.js';
import TrackingService from './services/TrackingService.js';
import PlaceholderService from './services/PlaceholderService.js';
import Utils from './services/Utils.js';
import SocialIconsLoaderService from './services/SocialIconsLoaderService.js';

let ClassImporter  = {
  Controller: Controller,
  FetchExecutor: FetchExecutor,
  HttpService: HttpService,
  HttpResponseHandler: HttpResponseHandler,
  UrlGenerator: UrlGenerator,
  RequestBuilder: RequestBuilder,
  ValidatorUtils: ValidatorUtils,
  EmailAddressValidator: EmailAddressValidator,
  LoginValidator: LoginValidator,
  LinkAccountValidator: LinkAccountValidator,
  RegisterValidator: RegisterValidator,
  TranslationMapper: TranslationMapper,
  TranslationService: TranslationService,
  EmailCaptureHandler: EmailCaptureHandler,
  LoginHandler: LoginHandler,
  OpenIdLoginHandler: OpenIdLoginHandler,
  ResetPasswordHandler: ResetPasswordHandler,
  LinkAccountHandler: LinkAccountHandler,
  RegisterHandler: RegisterHandler,
  ViewBuilder: ViewBuilder,
  ErrorHandler: ErrorHandler,
  TrackingService: TrackingService,
  PlaceholderService: PlaceholderService,
  Utils: Utils,
  SocialIconsLoaderService: SocialIconsLoaderService
};

export default ClassImporter;



// WEBPACK FOOTER //
// ./src/library/ClassImporter.js